
export const initDiscography = () => {
	initAlbumEvent();
	initLyricsEvent()


};


const initAlbumEvent =() => {
	const albumSelector= $('.js-sp-slide--album')
	if(albumSelector.length>0){
		albumSelector.on('click',function(e){
			const AlbumLink= $(this).attr("data-album")

			$.get(
				AlbumLink,
				function(data){
					$(".albumDetailContainer").html(data);
					initLyricsEvent();
				},

			);
			e.preventDefault();
		});
	}


};

const initLyricsEvent =() => {
	const lyricsSelector= $('.js-albumLyrics')
	if(lyricsSelector.length>0){
		lyricsSelector.on('click',function(e){
			const lyricsId= $(this).attr("data-lyrics_id")
			const lyricsContainer= $(".tracklistContainer.tracklistContainer--lyrics")
			const selectedLyrics= $(".albumLyricsContent--" + lyricsId);
			if(selectedLyrics.length>0){
				lyricsContainer.html("");
				lyricsContainer.html(selectedLyrics[0].innerHTML);
			}
			e.preventDefault();
		});
	}


};
